import { CHANGELANG } from './actions'
import { applyDocumentLang, packFor, readSavedLang, writeSavedLang } from './langPacks'

const start = packFor(readSavedLang())
applyDocumentLang(start.code)

const initialState = start

export default (state = initialState, actions) => {
  switch (actions.type) {
    case CHANGELANG: {
      const next = packFor(writeSavedLang(actions.lang))
      return { ...state, ...next }
    }
    default:
      return state
  }
}
